function LayoutSetting({
    getCardOne = () => { },
}) {
    return (
        <div style={{ width: "100%" }}>
            {getCardOne()}
        </div>
    )
}
export default LayoutSetting;